import { render, staticRenderFns } from "./AddScrapbook.vue?vue&type=template&id=d9bb04c4&scoped=true&"
import script from "./AddScrapbook.vue?vue&type=script&lang=js&"
export * from "./AddScrapbook.vue?vue&type=script&lang=js&"
import style0 from "./AddScrapbook.vue?vue&type=style&index=0&id=d9bb04c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bb04c4",
  null
  
)

export default component.exports